<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ detail__detail? 'DÉTAIL DE LA' : (Object.entries(this.data).length === 0 ? "NOUVELLE" : "MODIFIER UNE") }} CATÉGORIE</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
                <p class="mt-5" >Catégorie <b style="color: #ff6141">*</b> </p>
                <vs-input 
                    :disabled="detail__detail"
                    :danger="error.name || verification_name"
                    :danger-text="verification_name ? 'Le nom de la catégorie est réquis.' : 'Le nom de la catégorie est incorrect.'"
                    v-model="input.name" class="w-full" name="item-code" />
                <vs-textarea :disabled="detail__detail" label="Description" v-model="input.comment" class="mt-5 w-full" />

            </div>
        </VuePerfectScrollbar>
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    var base_self;
    var input_tempon = {
        id: null,
        name: '',
        comment: ''
    };

    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            data: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
                error: {
                    name: false
                },
                input: {},
                detail__detail: false,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
            isFormValid() {
                var is_valide = true;
                if (!this.input.name || this.input.name === '') is_valide = false;
                return is_valide;
            },
            verification_name () {
                return (base_self.input.name.length !== 0) ? false : true;
            }
        },
        methods: {
            async submitData() {
                var input = JSON.parse(JSON.stringify(this.input));
                
                if(!input.id) {     
                    let response = await base_self.$store.state.categories_requests_create(input);
                    console.log('response: ', response);
                    if (response.data.status) {
                        window.GETCCMT.success('La catégorie de demande est crée avec succès.', response);
                        console.log('response: ', response);
                        window.CategoriesApp.getCategories_requests();

                        this.$emit('closeSidebar');
                        this.initValues()
                    } else {
                        window.GETCCMT.error({ message: 'La création de la catégorie de demande a échouée.' });
                    }
                } else if (input.id) {
                    let response = await base_self.$store.state.categories_requests_update(input);
                        console.log('response: ', response);
                    if (response.data.status) {
                        window.GETCCMT.success('La catégorie de demande est modifiée avec succès.', response);
                        console.log('response: ', response);
                        window.CategoriesApp.getCategories_requests();

                        this.$emit('closeSidebar');
                        this.initValues()
                    } else {
                        window.GETCCMT.error({ message: 'La modification de la catégorie de demande a échouée.' });
                    }
                }
            },
            initValues() {
                this.input = JSON.parse(JSON.stringify(input_tempon));
                this.detail__detail = false;
                window.CategoriesApp.sidebarData.detail__detail = false;
            }
        },
        watch: {
            async isSidebarActive() {
                this.initValues();
                if(window.CategoriesApp.sidebarData.id) {
                    let response = await base_self.$store.state.categories_requests_detail({}, window.CategoriesApp.sidebarData.id);

                    this.input = JSON.parse(JSON.stringify(response.data));
                    console.log('categories_requests_detail response :    ::::::::::::::::::::::::', response);

                    this.detail__detail = window.CategoriesApp.detail__detail;
                }
            }
        },
        created() {
            window.EditCategory = this;
            base_self = this;
            base_self.initValues()
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
</style>